const locales = ['fi', 'sv', 'en'] as const
export const localeLabels = {
  fi: 'Suomi',
  sv: 'Svenska',
  en: 'English'
}
export default locales
